import React from "react";
import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";

const ShippingLabel = ({
  shippingLabelWFData,
  formatDueDeliveryDate,
  isVisible,
}) => {
  // Format date and time separately using date-fns
  const formatGermanDateTime = (dateString) => {
    if (!dateString) return { date: "", time: "" };

    try {
      const date =
        typeof dateString === "string" ? parseISO(dateString) : dateString;
      return {
        date: format(date, "E. dd.MM.yyyy", { locale: de }), // Short day name with period (e.g., Di.)
        time: format(date, "HH:mm 'Uhr'", { locale: de }),
      };
    } catch (e) {
      console.error("Error formatting date:", e);
      return { date: dateString, time: "" };
    }
  };

  const { date, time } = formatGermanDateTime(
    shippingLabelWFData?.deliveryDate
  );

  return (
    <div
      id="shipping-label"
      className={`border-gray border px-8 pb-3 pt-4 m-auto rounded-3xl relative ${
        !isVisible ? "hidden" : ""
      }`}
      style={{
        width: "559px",
        minHeight: "auto",
        backgroundColor: "white",
        overflow: "hidden",
        pageBreakInside: "avoid",
        breakInside: "avoid",
      }}
    >
      <div className="flex items-start justify-between gap-2 font-interBold">
        <div>
          <p className="text-2xl text-gray-600 mb-2">
            {shippingLabelWFData?.dentistName}
          </p>
          <p className="text-2xl text-gray-600 mb-2">
            {shippingLabelWFData?.patientName}
          </p>
          <p className="text-2xl pt-3 text-gray-600 mb-0">{date}</p>
          <p className="text-2xl text-gray-600 mb-2">{time}</p>
        </div>
        <div className="flex items-center justify-end text-gray-500 w-40">
          <p className="text-2xl text-gray-600 font-interBold mb-0">
            {shippingLabelWFData?.geoCode}
          </p>
        </div>
      </div>
      <br />
      <br />
      <br />
      <img
        src="./icons/elephant.svg"
        alt="Elephant"
        className="absolute bottom-0 right-0 w-55 h-55 opacity-50"
      />
    </div>
  );
};

export default ShippingLabel;
